import { render, staticRenderFns } from "./SettingsRationModal.vue?vue&type=template&id=5b28710f&scoped=true&lang=pug"
import script from "./SettingsRationModal.vue?vue&type=script&lang=js"
export * from "./SettingsRationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28710f",
  null
  
)

export default component.exports